module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-slide borde-dashed"
  }, [_c('div', {
    staticClass: "textos",
    attrs: {
      "id": "banner-slide-contain",
      "tabindex": "0"
    }
  }, [_vm._l((_vm.numeroBotones), function(item, index) {
    return (index + 1 === _vm.contenidoActual) ? _vm._t('cont' + index) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos && (_vm.contenidoActual > 0)) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "banner-buttons"
  }, _vm._l((_vm.numeroBotones), function(item, index) {
    return _c('button', {
      class: index + 1 === _vm.contenidoActual ? 'active' : '',
      attrs: {
        "id": 'bot-banner-slide-' + index
      },
      on: {
        "click": function($event) {
          _vm.showCont(index)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c738a42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BannerSlide.vue
// module id = 945
// module chunks = 1